import {styled} from '@esgi/ui/theme';
import {Select} from '@esgi/ui/controls';

export const StyledSelectField = styled(Select.Field, {
	height: 41,
});